<div class="d-flex h-100 align-items-center login-background">
    <div class="card mx-auto login-card" style="width: 30rem; height: 18rem;">
        <div class="card-body">
            <div class="text-center" style="position: absolute; bottom: 1rem; left: 1rem; right: 1rem;">
                <div style="opacity: 0.9;">
                    <div class="mb-3">
                        <input #email type="email" placeholder="Email" class="form-control" [disabled]="progress" (keyup.enter)="login(email.value, password.value)">
                    </div>
                    <div class="mb-3">
                        <input #password type="password" placeholder="Password" class="form-control" [disabled]="progress" (keyup.enter)="login(email.value, password.value)">
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary" [class.progress-bar-striped]="progress" [class.progress-bar-animated]="progress" [disabled]="progress" (click)="login(email.value, password.value)">
                        <i class="fas fa-sign-in-alt"></i> Login
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>